import { Unit } from 'types/products'

type EmailBodyProps = {
  fullName: string
  orderProducts: Array<{
    symbol: string
    size: string
    amount: number
    unit: Unit
    feature: string | null
  }>
}

function getEmailBody({ fullName, orderProducts }: EmailBodyProps): string {
  return `
Szanowni Państwo,

Proszę o realizację zamówienia dla:
${orderProducts.map((product) => `- ${product.symbol}, wymiar: ${product.size}, ilość: ${product.amount} ${product.unit}, ${product.feature}`).join('\n')}

Pozdrawiam,
${fullName}
abcfirany.pl
`
}

type EmailProps = {
  manufacturerEmail: string
} & EmailBodyProps

const subject = 'Zamówienie abcfirany'

export function generateMailToLink({ manufacturerEmail, fullName, orderProducts }: EmailProps): string {
  const body = getEmailBody({ fullName, orderProducts })

  const cc = 'info@abcfirany.pl'

  return `mailto:${manufacturerEmail}?cc=${encodeURIComponent(cc)}&subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
}
